<template>
  <div class="tgh-residential-details">
    <router-link to="/residential" class="tgh-close-rd">
      <img src="../assets/images/close.png" alt="">
    </router-link>
    <hooper>
      <slide>
        <div class="tgh-rd-starter">
          <img :src="residential.photo" alt="">
          <div class="tgh-rds-detail">
            <h1>{{ $route.params.res }}</h1>
            <p v-html="residential.description"></p>
          </div>
        </div>
      </slide>
      <slide v-for="(rim,rimIndex) in residential.images" :key="`rim-im-${rimIndex}`">
        <div class="tgh-rd-images">
          <img :src="rim.photo" alt="">
        </div>
      </slide>
      <hooper-navigation slot="hooper-addons"></hooper-navigation>
    </hooper>
  </div>
</template>

<script>
import {apiUrl} from '../config'
import axios from 'axios'
import {
  Hooper,
  Slide,
  Navigation as HooperNavigation
} from 'hooper';
import 'hooper/dist/hooper.css';

export default {
  name: 'ResidentialDetails',
  components: {
    Hooper,
    Slide,
    HooperNavigation
  },
  
  data() {
    return {
      residential : []  
    }
  },
  methods : {
    getData(){
      let vm = this
      let url = apiUrl+'/residential/get'
      let data = {
        title : this.$route.params.res
      }
      axios.post(
          url,
          data
      )
      .then(response => {
          if(response.data.status){
              vm.residential = response.data.data
          }
      })
      .catch(e => {
          console.log('Internal server error')
      })
    }
  },
  mounted() {
    this.getData()
    this.$store.commit('goFullScreen')
  },
  destroyed() {
    this.$store.commit('exitFullScreen')
  }
}
</script>
